export default __webpack_public_path__ + "static/media/109.92108299.jpeg";